import { graphql, useStaticQuery } from 'gatsby';
import { Query } from '../types/graphql-types';

export const GetLinkFromId = (id: string): string | undefined => {
  if (!id) {
    return undefined;
  }

  const data: Query = useStaticQuery(graphql`
    query {
      # Get all non static pages, eg. contentful pages.
      allSitePage(filter: { context: { id: { ne: null } } }) {
        edges {
          node {
            context {
              id
            }
            path
          }
        }
      }
    }
  `);

  if (!data.allSitePage || !data.allSitePage.edges) {
    return undefined;
  }

  const match = data.allSitePage.edges.find(
    edge => edge!.node!.context!.id === id
  );

  if (!match || !match.node) {
    return undefined;
  }

  return match!.node!.path as string;
};
